<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/3rwtUM/tc-custom/9781466865730.jpg?1732162256657" alt="This image is the cover for the book Informal History of the Hugos"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Informal History of the Hugos
      </h1>
      <p class="bookDescription body article font2">
        <p><b>Engaged, passionate, and consistently entertaining, <i>An Informal History of the Hugos</i> is a book about the renowned science fiction award for the many who enjoyed Jo Walton's previous collection of writing from <i>Tor.com</i>, the Locus Award-winning <i>What Makes This Book So Great</i>.</b><br/><br/>The Hugo Awards, named after pioneer science-fiction publisher Hugo Gernsback, and voted on by members of the World Science Fiction Society, have been presented since 1953. They are widely considered the most prestigious awards in science fiction.<br/><br/>Between 2010 and 2013, Jo Walton wrote a series of posts for <i>Tor.com</i>, surveying the Hugo finalists and winners from the award's inception up to the year 2000. Her contention was that each year's full set of finalists generally tells a meaningful story about the state of science fiction at that time.<br/><br/>Walton's cheerfully opinionated and vastly well-informed posts provoked valuable conversation among the field's historians. Now these posts, lightly revised, have been gathered into this book, along with a small selection of the comments posted by SF luminaries such as Rich Horton, Gardner Dozois, and David G. Hartwell.<br/><br/><b>"A remarkable guided tour through the field—a kind of nonfiction companion to <i>Among Others</i>. It's very good. It's great."—<i>New York Times</i> bestselling author Cory Doctorow<i>, Boing Boing </i>on <i>What Makes This Book So Great</i></b><br/><br/>At the Publisher's request, this title is being sold without Digital Rights Management Software (DRM) applied.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jo Walton
      </h2>
      
      <p class="authorDescription body article">JO WALTON won the James Tiptree Jr. Memorial Award for <I>My Real Children</I> and  the Locus Award for <I>What Makes This Book So Great</I> in 2015. Three years prior, her novel <I>Among Others</I> won the Hugo and Nebula Awards. Before that, <I>Tooth and Claw</I> won the World Fantasy Award in 2004. A native of Wales, Walton lives in Montreal.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Tom Doherty Associates
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0d709cd3